module.exports = __webpack_public_path__ + "img/num_44.36a5da93.png";